// extracted by mini-css-extract-plugin
export default {"loader-wrapper":"AutoCreateTopic_loader-wrapper__CUkPj","error":"AutoCreateTopic_error__7+g7H","cancelButton":"AutoCreateTopic_cancelButton__HXBa1"};